var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"dense":"","hide-default-footer":"","disable-pagination":""}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }